import {
  CLEAN_DETAIL_PURCHASE_AIRALO,
  CLEAN_DETAIL_PURCHASE_AIRALO_ERROR,
  DETAIL_PURCHASE_AIRALO,
  DETAIL_PURCHASE_AIRALO_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  response: undefined,
  status: undefined,
  state: undefined,
};

export default function purchaseDetailsAiraloReducer(state = initialState, action) {
  switch (action.type) {
    case DETAIL_PURCHASE_AIRALO:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'success',
      };

    case DETAIL_PURCHASE_AIRALO_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_DETAIL_PURCHASE_AIRALO:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_DETAIL_PURCHASE_AIRALO_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
